{
  "familyId": "GET-VOLGORDE-BEWERKING",
  "questions": [
    {
      "id": "GET-VOLGORDE-BEWERKING-001",
      "familyId": "GET-VOLGORDE-BEWERKING",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "bewerkingen",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Wat is 3 + 4 × 2?",
      "options": ["11", "14", "10", "24"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde van bewerkingen",
            "content": "Onthoud: Haakjes → Machten → × en ÷ → + en −. Vermenigvuldigen gaat altijd vóór optellen. Dus: 3 + 4 × 2 → eerst 4 × 2 = 8, dan 3 + 8 = 11.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_keer_voor_plus",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: gebruik de rekenregels — vermenigvuldigen gaat vóór optellen. Stap 1: Eerst × : 4 × 2 = 8. Stap 2: Dan + : 3 + 8 = 11. Onthoud: Meneer Van Dansen Wacht Op Antwoord (Machtsverheffen, Vermenigvuldigen/Delen, Worteltrekken, Optellen/Aftrekken).",
        "solutionSteps": [
          "Eerst × : 4 × 2 = 8",
          "Dan + : 3 + 8 = 11"
        ],
        "distractorExplanations": {
          "0": "Goed! Eerst vermenigvuldigen: 4 × 2 = 8. Dan optellen: 3 + 8 = 11.",
          "1": "Veelgemaakte fout: van links naar rechts rekenen. 3 + 4 = 7, dan 7 × 2 = 14. Maar vermenigvuldigen gaat vóór optellen!",
          "2": "Veelgemaakte fout: de verkeerde getallen vermenigvuldigen. 3 × 2 = 6, plus 4 = 10. Maar het is 4 × 2, niet 3 × 2.",
          "3": "Veelgemaakte fout: alles vermenigvuldigen. 3 × 4 × 2 = 24. Maar de + is een optelling, geen vermenigvuldiging."
        }
      }
    },
    {
      "id": "GET-VOLGORDE-BEWERKING-002",
      "familyId": "GET-VOLGORDE-BEWERKING",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "bewerkingen",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Wat is (5 + 3) × 4?",
      "options": ["32", "17", "20", "60"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Haakjes gaan altijd eerst",
            "content": "Alles wat tussen haakjes staat, bereken je als eerste. (5 + 3) = 8. Daarna: 8 × 4 = 32. Haakjes hebben de hoogste prioriteit.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_haakjes",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Strategie: haakjes gaan altijd eerst. Stap 1: Haakjes: 5 + 3 = 8. Stap 2: Vermenigvuldigen: 8 × 4 = 32. Onthoud: haakjes hebben de hoogste prioriteit.",
        "solutionSteps": [
          "Haakjes: 5 + 3 = 8",
          "Vermenigvuldigen: 8 × 4 = 32"
        ],
        "distractorExplanations": {
          "0": "Goed! Eerst de haakjes: 5 + 3 = 8. Dan: 8 × 4 = 32.",
          "1": "Veelgemaakte fout: de haakjes negeren. Zonder haakjes: 5 + 3 × 4 = 5 + 12 = 17. Maar de haakjes veranderen de volgorde!",
          "2": "Veelgemaakte fout: 5 × 4 = 20 (de haakjes overslaan en alleen het eerste getal vermenigvuldigen). De haakjes zeggen: eerst 5 + 3 = 8.",
          "3": "Veelgemaakte fout: alles vermenigvuldigen. 5 × 3 × 4 = 60. Maar de + in de haakjes is een optelling."
        }
      }
    },
    {
      "id": "GET-VOLGORDE-BEWERKING-003",
      "familyId": "GET-VOLGORDE-BEWERKING",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "bewerkingen",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Wat is 20 − 12 ÷ 4?",
      "options": ["17", "2", "8", "23"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Delen gaat vóór aftrekken",
            "content": "Volgorde: × en ÷ gaan vóór + en −. Dus: eerst 12 ÷ 4 = 3. Dan: 20 − 3 = 17. Niet van links naar rechts!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_delen_voor_aftrekken",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: delen gaat vóór aftrekken. Stap 1: Eerst ÷ : 12 ÷ 4 = 3. Stap 2: Dan − : 20 − 3 = 17.",
        "solutionSteps": [
          "Eerst ÷ : 12 ÷ 4 = 3",
          "Dan − : 20 − 3 = 17"
        ],
        "distractorExplanations": {
          "0": "Goed! Eerst delen: 12 ÷ 4 = 3. Dan aftrekken: 20 − 3 = 17.",
          "1": "Veelgemaakte fout: van links naar rechts rekenen. 20 − 12 = 8, dan 8 ÷ 4 = 2. Maar delen gaat vóór aftrekken!",
          "2": "Veelgemaakte fout: eerst aftrekken. 20 − 12 = 8, maar je moet eerst delen: 12 ÷ 4 = 3.",
          "3": "Veelgemaakte fout: optellen in plaats van aftrekken. 20 + 3 = 23. Maar het is 20 − 3 = 17."
        }
      }
    },
    {
      "id": "GET-VOLGORDE-BEWERKING-004",
      "familyId": "GET-VOLGORDE-BEWERKING",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "bewerkingen",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Wat is 2 × (10 − 3) + 5?",
      "options": ["19", "24", "14", "9"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap: haakjes → × → +",
            "content": "Stap 1: Haakjes eerst: (10 − 3) = 7. Stap 2: Vermenigvuldigen: 2 × 7 = 14. Stap 3: Optellen: 14 + 5 = 19. De 5 staat buiten de haakjes, dus die tel je als laatste op.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_haakjes_combinatie",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: haakjes eerst, dan vermenigvuldigen, dan optellen. Stap 1: Haakjes: 10 − 3 = 7. Stap 2: Vermenigvuldigen: 2 × 7 = 14. Stap 3: Optellen: 14 + 5 = 19.",
        "solutionSteps": [
          "Haakjes: 10 − 3 = 7",
          "Vermenigvuldigen: 2 × 7 = 14",
          "Optellen: 14 + 5 = 19"
        ],
        "distractorExplanations": {
          "0": "Goed! (10 − 3) = 7, dan 2 × 7 = 14, dan 14 + 5 = 19.",
          "1": "Veelgemaakte fout: de 5 ook vermenigvuldigen. 2 × (10 − 3 + 5) = 2 × 12 = 24. Maar de 5 staat buiten de haakjes.",
          "2": "Veelgemaakte fout: de optelling vergeten. 2 × 7 = 14 is alleen het eerste deel. Je moet nog + 5 doen: 14 + 5 = 19.",
          "3": "Veelgemaakte fout: de volgorde door elkaar halen. Controleer stap voor stap: haakjes → × → + geeft 19."
        }
      }
    },
    {
      "id": "GET-VOLGORDE-BEWERKING-005",
      "familyId": "GET-VOLGORDE-BEWERKING",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "bewerkingen",
      "subSkill": "volgorde_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Welke bewerking doe je EERST bij: 8 + 6 × 3 − 2?",
      "options": ["6 × 3", "8 + 6", "3 − 2", "8 + 6 × 3"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zoek de × of ÷ zonder haakjes",
            "content": "Er zijn geen haakjes. Zoek dan de × of ÷: dat is 6 × 3. Die doe je als eerste. Daarna van links naar rechts: 8 + 18 − 2 = 24.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volgorde_herkennen",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: pas de voorrangsregels toe. Stap 1: Geen haakjes → kijk naar vermenigvuldigen/delen. Stap 2: Er is één vermenigvuldiging: 6 × 3. Stap 3: Die doe je eerst. Daarna van links naar rechts: 8 + 18 − 2 = 24.",
        "solutionSteps": [
          "Geen haakjes → zoek × of ÷",
          "Gevonden: 6 × 3 → doe dit eerst",
          "Dan van links naar rechts: 8 + 18 − 2 = 24"
        ],
        "distractorExplanations": {
          "0": "Goed! Vermenigvuldigen gaat vóór optellen en aftrekken. 6 × 3 = 18 doe je eerst.",
          "1": "Veelgemaakte fout: van links naar rechts beginnen. 8 + 6 = 14 is niet de eerste stap. Vermenigvuldigen heeft voorrang!",
          "2": "Veelgemaakte fout: van rechts naar links beginnen. 3 − 2 = 1 is niet de eerste stap. Vermenigvuldigen heeft voorrang!",
          "3": "Veelgemaakte fout: meerdere bewerkingen tegelijk doen. Je doet eerst alleen 6 × 3 = 18. Daarna: 8 + 18 − 2."
        }
      }
    }
  ]
}
